export const ModuleError = {
  ProgressNotFound: 'ProgressNotFound',
  ProgressError: 'ProgressError'
}